// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkRouteImport } from './routes/work'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SitemapDotxmlRouteImport } from './routes/sitemap[.]xml'
import { Route as RobotsDottxtRouteImport } from './routes/robots[.]txt'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as NewsRouteImport } from './routes/news'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CompanyRouteImport } from './routes/company'
import { Route as CareersRouteImport } from './routes/careers'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ActivateAccountRouteImport } from './routes/activate-account'
import { Route as R404RouteImport } from './routes/404'
import { Route as LocaleRouteRouteImport } from './routes/$locale/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ApiIndexRouteImport } from './routes/api/index'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as AdminSplatRouteImport } from './routes/admin/$'
import { Route as LocaleIndexRouteImport } from './routes/$locale/index'
import { Route as LocaleWorkRouteImport } from './routes/$locale/work'
import { Route as LocaleCompanyRouteImport } from './routes/$locale/company'
import { Route as LocaleCalendarRouteImport } from './routes/$locale/calendar'
import { Route as Locale500RouteImport } from './routes/$locale/500'
import { Route as LocaleSplatRouteImport } from './routes/$locale/$'
import { Route as LocaleNewsRouteRouteImport } from './routes/$locale/news/route'
import { Route as LocaleContactRouteRouteImport } from './routes/$locale/contact/route'
import { Route as LocaleCareersRouteRouteImport } from './routes/$locale/careers/route'
import { Route as DashboardContractMakerSplatRouteImport } from './routes/dashboard/contract-maker/$'
import { Route as DashboardSectionSplatRouteImport } from './routes/dashboard/$section/$'
import { Route as LocaleNewsIndexRouteImport } from './routes/$locale/news/index'
import { Route as LocaleNewsSlugRouteImport } from './routes/$locale/news/$slug'
import { Route as LocaleContactIndexRouteImport } from './routes/$locale/contact/index'
import { Route as LocaleContactThanksRouteImport } from './routes/$locale/contact/thanks'
import { Route as LocaleContactSlugRouteImport } from './routes/$locale/contact/$slug'
import { Route as LocaleCareersIndexRouteImport } from './routes/$locale/careers/index'
import { Route as LocaleCareersSlugRouteImport } from './routes/$locale/careers/$slug'
import { Route as ApiDashboardProfileLanguageRouteImport } from './routes/api/dashboard/profile/language'
import { Route as ApiDashboardProfileImageRouteImport } from './routes/api/dashboard/profile/image'
import { Route as ApiDashboardAuthSessionRouteImport } from './routes/api/dashboard/auth/session'
import { Route as ApiDashboardAuthRefreshRouteImport } from './routes/api/dashboard/auth/refresh'
import { Route as ApiDashboardAuthPasswordResetRouteImport } from './routes/api/dashboard/auth/password-reset'
import { Route as ApiDashboardAuthMfaRouteImport } from './routes/api/dashboard/auth/mfa'
import { Route as ApiDashboardAuthLogoutRouteImport } from './routes/api/dashboard/auth/logout'
import { Route as ApiDashboardAuthLoginRouteImport } from './routes/api/dashboard/auth/login'
import { Route as ApiDashboardAuthCallbackRouteImport } from './routes/api/dashboard/auth/callback'
import { Route as ApiDashboardAssetsPresignRouteImport } from './routes/api/dashboard/assets/presign'
import { Route as ApiDashboardAuthPasswordResetConfirmRouteImport } from './routes/api/dashboard/auth/password-reset/confirm'

const WorkRoute = WorkRouteImport.update({
            id: '/work',path: '/work',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SitemapDotxmlRoute = SitemapDotxmlRouteImport.update({
            id: '/sitemap.xml',path: '/sitemap.xml',getParentRoute: () => rootRouteImport
          })
const RobotsDottxtRoute = RobotsDottxtRouteImport.update({
            id: '/robots.txt',path: '/robots.txt',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const NewsRoute = NewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CompanyRoute = CompanyRouteImport.update({
            id: '/company',path: '/company',getParentRoute: () => rootRouteImport
          })
const CareersRoute = CareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => rootRouteImport
          })
const CalendarRoute = CalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const ActivateAccountRoute = ActivateAccountRouteImport.update({
            id: '/activate-account',path: '/activate-account',getParentRoute: () => rootRouteImport
          })
const R404Route = R404RouteImport.update({
            id: '/404',path: '/404',getParentRoute: () => rootRouteImport
          })
const LocaleRouteRoute = LocaleRouteRouteImport.update({
            id: '/$locale',path: '/$locale',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ApiIndexRoute = ApiIndexRouteImport.update({
            id: '/api/',path: '/api/',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const DashboardIndexRoute = DashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardRoute
          })
const AdminSplatRoute = AdminSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => AdminRoute
          })
const LocaleIndexRoute = LocaleIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleRouteRoute
          })
const LocaleWorkRoute = LocaleWorkRouteImport.update({
            id: '/work',path: '/work',getParentRoute: () => LocaleRouteRoute
          })
const LocaleCompanyRoute = LocaleCompanyRouteImport.update({
            id: '/company',path: '/company',getParentRoute: () => LocaleRouteRoute
          })
const LocaleCalendarRoute = LocaleCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => LocaleRouteRoute
          })
const Locale500Route = Locale500RouteImport.update({
            id: '/500',path: '/500',getParentRoute: () => LocaleRouteRoute
          })
const LocaleSplatRoute = LocaleSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => LocaleRouteRoute
          })
const LocaleNewsRouteRoute = LocaleNewsRouteRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => LocaleRouteRoute
          })
const LocaleContactRouteRoute = LocaleContactRouteRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => LocaleRouteRoute
          })
const LocaleCareersRouteRoute = LocaleCareersRouteRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => LocaleRouteRoute
          })
const DashboardContractMakerSplatRoute = DashboardContractMakerSplatRouteImport.update({
            id: '/contract-maker/$',path: '/contract-maker/$',getParentRoute: () => DashboardRoute
          })
const DashboardSectionSplatRoute = DashboardSectionSplatRouteImport.update({
            id: '/$section/$',path: '/$section/$',getParentRoute: () => DashboardRoute
          })
const LocaleNewsIndexRoute = LocaleNewsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleNewsRouteRoute
          })
const LocaleNewsSlugRoute = LocaleNewsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => LocaleNewsRouteRoute
          })
const LocaleContactIndexRoute = LocaleContactIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleContactRouteRoute
          })
const LocaleContactThanksRoute = LocaleContactThanksRouteImport.update({
            id: '/thanks',path: '/thanks',getParentRoute: () => LocaleContactRouteRoute
          })
const LocaleContactSlugRoute = LocaleContactSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => LocaleContactRouteRoute
          })
const LocaleCareersIndexRoute = LocaleCareersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleCareersRouteRoute
          })
const LocaleCareersSlugRoute = LocaleCareersSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => LocaleCareersRouteRoute
          })
const ApiDashboardProfileLanguageRoute = ApiDashboardProfileLanguageRouteImport.update({
            id: '/api/dashboard/profile/language',path: '/api/dashboard/profile/language',getParentRoute: () => rootRouteImport
          })
const ApiDashboardProfileImageRoute = ApiDashboardProfileImageRouteImport.update({
            id: '/api/dashboard/profile/image',path: '/api/dashboard/profile/image',getParentRoute: () => rootRouteImport
          })
const ApiDashboardAuthSessionRoute = ApiDashboardAuthSessionRouteImport.update({
            id: '/api/dashboard/auth/session',path: '/api/dashboard/auth/session',getParentRoute: () => rootRouteImport
          })
const ApiDashboardAuthRefreshRoute = ApiDashboardAuthRefreshRouteImport.update({
            id: '/api/dashboard/auth/refresh',path: '/api/dashboard/auth/refresh',getParentRoute: () => rootRouteImport
          })
const ApiDashboardAuthPasswordResetRoute = ApiDashboardAuthPasswordResetRouteImport.update({
            id: '/api/dashboard/auth/password-reset',path: '/api/dashboard/auth/password-reset',getParentRoute: () => rootRouteImport
          })
const ApiDashboardAuthMfaRoute = ApiDashboardAuthMfaRouteImport.update({
            id: '/api/dashboard/auth/mfa',path: '/api/dashboard/auth/mfa',getParentRoute: () => rootRouteImport
          })
const ApiDashboardAuthLogoutRoute = ApiDashboardAuthLogoutRouteImport.update({
            id: '/api/dashboard/auth/logout',path: '/api/dashboard/auth/logout',getParentRoute: () => rootRouteImport
          })
const ApiDashboardAuthLoginRoute = ApiDashboardAuthLoginRouteImport.update({
            id: '/api/dashboard/auth/login',path: '/api/dashboard/auth/login',getParentRoute: () => rootRouteImport
          })
const ApiDashboardAuthCallbackRoute = ApiDashboardAuthCallbackRouteImport.update({
            id: '/api/dashboard/auth/callback',path: '/api/dashboard/auth/callback',getParentRoute: () => rootRouteImport
          })
const ApiDashboardAssetsPresignRoute = ApiDashboardAssetsPresignRouteImport.update({
            id: '/api/dashboard/assets/presign',path: '/api/dashboard/assets/presign',getParentRoute: () => rootRouteImport
          })
const ApiDashboardAuthPasswordResetConfirmRoute = ApiDashboardAuthPasswordResetConfirmRouteImport.update({
            id: '/confirm',path: '/confirm',getParentRoute: () => ApiDashboardAuthPasswordResetRoute
          })





const LocaleCareersRouteRouteChildren = {
  LocaleCareersSlugRoute: LocaleCareersSlugRoute,LocaleCareersIndexRoute: LocaleCareersIndexRoute
}

const LocaleCareersRouteRouteWithChildren = LocaleCareersRouteRoute._addFileChildren(LocaleCareersRouteRouteChildren)




const LocaleContactRouteRouteChildren = {
  LocaleContactSlugRoute: LocaleContactSlugRoute,LocaleContactThanksRoute: LocaleContactThanksRoute,LocaleContactIndexRoute: LocaleContactIndexRoute
}

const LocaleContactRouteRouteWithChildren = LocaleContactRouteRoute._addFileChildren(LocaleContactRouteRouteChildren)




const LocaleNewsRouteRouteChildren = {
  LocaleNewsSlugRoute: LocaleNewsSlugRoute,LocaleNewsIndexRoute: LocaleNewsIndexRoute
}

const LocaleNewsRouteRouteWithChildren = LocaleNewsRouteRoute._addFileChildren(LocaleNewsRouteRouteChildren)



const LocaleRouteRouteChildren = {
  LocaleCareersRouteRoute: LocaleCareersRouteRouteWithChildren,LocaleContactRouteRoute: LocaleContactRouteRouteWithChildren,LocaleNewsRouteRoute: LocaleNewsRouteRouteWithChildren,LocaleSplatRoute: LocaleSplatRoute,Locale500Route: Locale500Route,LocaleCalendarRoute: LocaleCalendarRoute,LocaleCompanyRoute: LocaleCompanyRoute,LocaleWorkRoute: LocaleWorkRoute,LocaleIndexRoute: LocaleIndexRoute
}

const LocaleRouteRouteWithChildren = LocaleRouteRoute._addFileChildren(LocaleRouteRouteChildren)




const AdminRouteChildren = {
  AdminSplatRoute: AdminSplatRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const DashboardRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,DashboardSectionSplatRoute: DashboardSectionSplatRoute,DashboardContractMakerSplatRoute: DashboardContractMakerSplatRoute
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(DashboardRouteChildren)




const ApiDashboardAuthPasswordResetRouteChildren = {
  ApiDashboardAuthPasswordResetConfirmRoute: ApiDashboardAuthPasswordResetConfirmRoute
}

const ApiDashboardAuthPasswordResetRouteWithChildren = ApiDashboardAuthPasswordResetRoute._addFileChildren(ApiDashboardAuthPasswordResetRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,LocaleRouteRoute: LocaleRouteRouteWithChildren,R404Route: R404Route,ActivateAccountRoute: ActivateAccountRoute,AdminRoute: AdminRouteWithChildren,CalendarRoute: CalendarRoute,CareersRoute: CareersRoute,CompanyRoute: CompanyRoute,ContactRoute: ContactRoute,DashboardRoute: DashboardRouteWithChildren,LoginRoute: LoginRoute,NewsRoute: NewsRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,RobotsDottxtRoute: RobotsDottxtRoute,SitemapDotxmlRoute: SitemapDotxmlRoute,TermsRoute: TermsRoute,WorkRoute: WorkRoute,AuthCallbackRoute: AuthCallbackRoute,ApiIndexRoute: ApiIndexRoute,ApiDashboardAssetsPresignRoute: ApiDashboardAssetsPresignRoute,ApiDashboardAuthCallbackRoute: ApiDashboardAuthCallbackRoute,ApiDashboardAuthLoginRoute: ApiDashboardAuthLoginRoute,ApiDashboardAuthLogoutRoute: ApiDashboardAuthLogoutRoute,ApiDashboardAuthMfaRoute: ApiDashboardAuthMfaRoute,ApiDashboardAuthPasswordResetRoute: ApiDashboardAuthPasswordResetRouteWithChildren,ApiDashboardAuthRefreshRoute: ApiDashboardAuthRefreshRoute,ApiDashboardAuthSessionRoute: ApiDashboardAuthSessionRoute,ApiDashboardProfileImageRoute: ApiDashboardProfileImageRoute,ApiDashboardProfileLanguageRoute: ApiDashboardProfileLanguageRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)